// extracted by mini-css-extract-plugin
export default {"item":"_5aJa","title":"K8nhY","apartmentType":"puh2b","type":"Ioksn","typeIcon":"d9CTu","link":"EfFaF","number":"Q2ZEs","date":"jU9Wo","arrow":"L_PCN","placeholder":"CgxrM"};